import { Table } from "reactstrap";
// import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
// import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
import styled from "styled-components";
import "./studentperformamance.css";
import { getMinValueFromData } from "utilFunctions/helperFunctions/testPerformanceHelpers";
import Typography from "Components/CommonComponents/Typography";
export const RiskStyledDiv = styled<any>("div")`
  background-color: ${(props: any) => props.color};
  border-radius: 4px;
  padding: 4px;
  width: fit-content;
`;
export const RiskStyledDSpan = styled<any>("span")`
  color: ${(props: any) => props.color};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
`;
interface IStudentPerformanceGraph {
  searchedFaculty?: any;
  mode?: any;
  tableloading?: any;
  tableHeading?: any;
  tableData?: any;
  filterState?: any;
  OverallPerformanceArray?: any;
  barArray?: any;
  div1Height?: any;
  graphLoading?: any;
}
const StudentPerformanceGraph = ({
  mode,
  tableHeading,
  OverallPerformanceArray,
  div1Height,
}: IStudentPerformanceGraph) => {
  const standardYaxisTicks = [100, 80, 60, 40, 20, 0];
  const minimumValue = getMinValueFromData(OverallPerformanceArray);
  const isMinMaxSubjectValueDefined = minimumValue !== undefined;
  let yAxisTicks = [];
  const negStandardYaxisTicks =
    minimumValue < -20
      ? [100, 80, 60, 40, 20, 0, -20, -40]
      : [100, 80, 60, 40, 20, 0, -20];
  if (minimumValue < 0) {
    yAxisTicks = isMinMaxSubjectValueDefined
      ? negStandardYaxisTicks
      : standardYaxisTicks;
  } else {
    yAxisTicks = standardYaxisTicks;
  }

  //getYValue function is used to get the Y axis label tick y-coordinates
  const getYValue = (index: number) => {
    const yAxisStartPoint =
      minimumValue < 0 ? (minimumValue < -20 ? 10 : 14) : 27;
    const yTickDiffValue =
      minimumValue < 0 ? (minimumValue < -20 ? 32 : 38) : 43;
    const highestValue = yAxisStartPoint + index * yTickDiffValue;
    return highestValue;
  };
  return (
    <div className="border">
      <div className="graphHeight">
        <div
          className={`d-flex flex-row ${
            ["testPerformance", "studentAttendance"].includes(mode)
              ? "justify-content-center"
              : "justify-content-start"
          } h-100`}
        >
          <div className="verticleTextContainer">
            <div className="verticleText rounded-sm">
              <Typography variant="subheadingSB1" color="secondary">
                {mode == "studentlop"
                  ? "LOP Percentage"
                  : mode == "studentAttendance"
                  ? "Total Attendance"
                  : "Score"}
              </Typography>
            </div>
          </div>
          <div className="xaxis">
            <svg className="font-gilroy font-medium text-xs h-100">
              <g className="recharts-layer recharts-cartesian-axis recharts-yAxis yAxis">
                {/* <line
                  orientation="left"
                  width="60"
                  height="240"
                  type="number"
                  x="5"
                  y="5"
                  className="recharts-cartesian-axis-line"
                  stroke="#ebebeb"
                  fill="none"
                  x1="65"
                  y1="5"
                  x2="65"
                  y2="245"
                ></line> */}
                <g className="recharts-cartesian-axis-ticks">
                  {yAxisTicks?.map((tickValue, index) => (
                    <g
                      className="recharts-layer recharts-cartesian-axis-tick"
                      key={tickValue + index}
                    >
                      <text
                        orientation="left"
                        width="60"
                        height="240"
                        type="number"
                        x="57"
                        y={getYValue(index)}
                        stroke="none"
                        fill="#666"
                        className="recharts-text recharts-cartesian-axis-tick-value"
                        textAnchor="end"
                      >
                        <tspan x="57" dy="1.0em">
                          {tickValue}% -
                        </tspan>
                      </text>
                    </g>
                  ))}
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
      <Table responsive className="table table-hover tableSideHead1">
        <tbody>
          {tableHeading.map((item: any, index: number) => (
            <tr key={index} className="text-center">
              {item.label == "Test Name" ? (
                <td
                  className="tableHeadCapitalize"
                  style={{ height: div1Height }}
                >
                  <strong className="tableHeadCapitalize">{item.label}</strong>
                </td>
              ) : item.label == "Segment" ? (
                <td className="segmentTableHead tableHeadCapitalize">
                  <strong className="tableHeadCapitalize">{item.label}</strong>
                </td>
              ) : (
                <td className="tableHeadCapitalize">
                  <strong className="tableHeadCapitalize">{item.label}</strong>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};
export default StudentPerformanceGraph;
